import { Modal } from "react-bootstrap";
import { BrandButton } from "../ui/buttons/buttons";
import { setCustomContext, setPopupStatus } from "../popup/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import { OneTimeTokenStatus } from "./useGlifeOpenExternalLink";
import { AppState } from "../RootReducer";
import { PopupStatus } from "../popup/PopupReducer";
import { useLocation } from "react-router";
import { t } from "../i18n";

const GlifeDisclaimerPopup = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const setHasUserClickedConfirm = () => dispatch(setCustomContext({ hasUserClickedConfirm: true }) as any);
  const isOneTimeTokenSuccess = useSelector((state: AppState) => state.popup?.customContext?.oneTimeTokenStatus === OneTimeTokenStatus.SUCCESS);
  const status = useSelector((state: AppState) => state.popup.popupStatus);
  const hasModalOpen = new URLSearchParams(location.search).has("type");
  const close = () => {
    dispatch(setPopupStatus(PopupStatus.HIDDEN));
  };

  return (
    <Modal show={status === PopupStatus.GLIFE_EXTERNAL_LINK_DISCLAIMER && !hasModalOpen} onHide={() => close()} aria-labelledby="contained-modal-title-vcenter" size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ textAlign: "center", marginBottom: "1rem" }}>Notice</Modal.Title>
      </Modal.Header>
      <Modal.Body className="promoteModalBody">
        <p>{t("glife.disclaimer.notice")}</p> <p>{t("glife.disclaimer.proceed")}</p>
        <BrandButton className="btn btn-cta full-width" disabled={!isOneTimeTokenSuccess} onClick={() => setHasUserClickedConfirm()}>
          {t("common.continue")}
        </BrandButton>
      </Modal.Body>
    </Modal>
  );
};

export default GlifeDisclaimerPopup;
